<template>
    <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                    <router-view v-on:logoutUser="logoutUser" :systemConfig="systemConfig"></router-view>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
  // This component is only here to provide a shared parent template to the child components, for UI purposes
  import {SystemConfigMixin, AppConfigMixin} from '@/views/mixins'

  export default {
    name: 'auth',
    mixins: [SystemConfigMixin, AppConfigMixin],
    props: {},
    computed: {},
    methods: {
      logoutUser (logoutHint) {
        console.log('[AUTH_ROOT]: Logging out user')
        if (logoutHint) {
          this.logoutHint = logoutHint
        }
        this.$firebaseClient.logoutUser()
          .catch((error) => {
            console.log(`[AUTH_ROOT]: Failed to logout user: ${error}`)
          })
      }
    }
  }
</script>
